import { render } from "./PropertyListComponent.vue?vue&type=template&id=02a02512&scoped=true&ts=true"
import script from "./PropertyListComponent.vue?vue&type=script&lang=ts"
export * from "./PropertyListComponent.vue?vue&type=script&lang=ts"

import "./PropertyListComponent.vue?vue&type=style&index=0&id=02a02512&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a02512"]])

export default __exports__